/**
 * `ENTITY_CHANGED` 구독 버스 — react-query를 안 쓰는 화면(useEffect 직접 조회)에 변경을 전달한다.
 *
 * `WebSocketProvider`가 이벤트마다 `bump(entity)`로 그 entity의 version을 올리고, 화면은
 * `hooks/useEntityChanged`로 관심 entity의 version 변화에 재조회를 건다. react-query 화면은 이 버스가
 * 필요 없다 — `lib/entityChanged.ts`의 무효화 표가 맡는다. 어느 쪽이 맡는지는 그 화면의 조회 방식으로
 * 정한다(`useQuery`면 표, `useEffect`면 이 버스).
 */
import { create } from 'zustand';
import type { EntityChangedEntity } from '../lib/entityChanged';

export type EntityVersions = Partial<Record<EntityChangedEntity, number>>;

interface EntityChangedStore {
  /** entity별 변경 카운터 — 값 자체는 의미 없고 변화만 본다. */
  versions: EntityVersions;
  /** 새 객체로 교체한다(selector가 참조 변화로 깨어나야 한다). */
  bump: (entity: EntityChangedEntity) => void;
}

export const useEntityChangedStore = create<EntityChangedStore>((set) => ({
  versions: {},
  bump: (entity) =>
    set((state) => ({
      versions: { ...state.versions, [entity]: (state.versions[entity] ?? 0) + 1 },
    })),
}));
